const messagesInPolish = {
    financialServices: "Usługi finansowe",
  };
  
  export { messagesInPolish };
  